<template>
	<svg class="link-icon" aria-hidden="true" :class="classes" @click="e=>$emit('click',e)">
		<use :xlink:href="'#'+icon"></use>
	</svg>
</template>

<script>
    export default {
        name: 'link-icon',
        props: {
            icon: {type: String, required: true},                                                       //图标名称
            loading: {type: Boolean, default: false},                                                   //是否为旋转图标
            size: null,                                                                                 //图标大小
            color: null,                                                                                //图标颜色
        },
        computed: {
            classes() {
                return {
                    'link-icon-loading': this.loading,
                };
            },
            styles() {
                let ret = {};
                !!this.size && (ret.fontSize = this.size);
                !!this.color && (ret.color = this.color);
                return ret;
            },
        },
    };
</script>

<style lang="scss">
	.link-icon {
		color: inherit;
		font-size: inherit;
		box-sizing: border-box;
		outline: none;

		/*阿里巴巴icon设置*/
		width: 1.1em;
		height: 1.1em;
		vertical-align: -0.15em;
		fill: currentColor;
		overflow: hidden;

		/*旋转图标*/
		&.link-icon-loading {
			animation: link-rotating 0.75s linear infinite;
		}
	}

	@keyframes link-rotating {
		from {
			transform: rotate(0deg);
		}
		50% {
			transform: rotate(180deg);
		}
		to {
			transform: rotate(360deg);
		}
	}

</style>
